import { Service } from '@/modules/Service/types'
import { IPermissionProps } from '@/types/shared'
import {
    getRegisterFormType,
    RegisterFormType,
    RegisterServiceTemplateProps,
    DefaultRegisterForm,
    VCloudRegisterForm,
    VnisRegisterForm,
    SwiftFederationRegisterForm,
} from '@/modules/Service/utils/templates'

/**
 * Map form types to their components
 */
const FormComponents: Record<
    RegisterFormType,
    React.FC<RegisterServiceTemplateProps>
> = {
    default: DefaultRegisterForm,
    vcloud: VCloudRegisterForm,
    vnis: VnisRegisterForm,
    'swift-federation': SwiftFederationRegisterForm,
}

interface RegisterServiceProps extends IPermissionProps {
    service: Service
    stepId?: number
}

/**
 * RegisterService component - renders template-specific registration form
 * Uses centralized template registry to determine form type
 */
const RegisterService: React.FC<RegisterServiceProps> = ({
    service,
    stepId,
}) => {
    // Get form type from centralized template config
    const formType = getRegisterFormType(
        service?.service_template,
        service?.product_group_name
    )

    // Get component for this form type
    const RegisterComponent = FormComponents[formType] || DefaultRegisterForm

    console.log('formType', formType)
    return <RegisterComponent service={service} stepId={stepId} />
}

export default RegisterService
